"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseWidgetTitle = exports.BaseWidgetSpaceContainer = exports.BaseWidgetHeader = exports.BaseWidgetContainer = void 0;
var _edSystem = require("@eduact/ed-system");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var BaseWidgetHeader = (0, _styledComponents["default"])(_edSystem.FlexLayout)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding-bottom: 6px;\n\tborder-bottom: 1px solid ", ";\n"])), function (props) {
  return props.theme.colors.silver;
});
exports.BaseWidgetHeader = BaseWidgetHeader;
var BaseWidgetContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tborder-radius: 15px;\n\twidth: 100%;\n\theight: 100%;\n\tbox-shadow: ", ";\n\t", ";\n\t", "\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\t", ";\n\t", ";\n\t", " {\n\t\tborder: ", ";\n\t}\n"])), function (_ref) {
  var withShadow = _ref.withShadow;
  return withShadow && '0 5px 6px 0 rgba(0, 0, 0, 0.16)';
}, (0, _styledSystem.variant)({
  prop: 'bg',
  scale: 'buttonColors'
}), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tmin-height: 13.6rem;\n\t}");
}, _styledSystem.layout, _styledSystem.space, BaseWidgetHeader, function (props) {
  return !props.withSeparator && 'none';
});
exports.BaseWidgetContainer = BaseWidgetContainer;
var BaseWidgetSpaceContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tpadding: 1.25rem;\n\tbackground: ", ";\n\tpadding: ", ";\n\twidth: 100%;\n\theight: 100%;\n"])), function (_ref3) {
  var contained = _ref3.contained;
  return contained && 'transparent';
}, function (_ref4) {
  var contained = _ref4.contained;
  return contained && '0';
});
exports.BaseWidgetSpaceContainer = BaseWidgetSpaceContainer;
var BaseWidgetTitle = _styledComponents["default"].h4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tmargin: 0;\n\tfont-size: 0.75rem;\n\tfont-weight: 600;\n\t", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tfont-size: 1.125rem;\n\t}");
});
exports.BaseWidgetTitle = BaseWidgetTitle;